export const GET_QUOTES = "GET_QUOTES";
export const GET_PERSON_NAMES = "GET_PERSON_NAMES";
